module.exports = __webpack_public_path__ + "fonts/Satoshi-BoldItalic.48d72c8.woff2";